import {
  Navigate,
  useParams,
  useSearchParams
} from 'react-router-dom';

import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';

/*
 * Redirects to defaultFlow and node/0
 * Does not add to navigation history
 */

export default function Redirect(): JSX.Element {
  const pathParams = useParams();
  const [queryParams] = useSearchParams();
  const redirectPath = buildValidFlowPath({ ...pathParams, queryParams });

  return (<Navigate replace to={redirectPath} />);
};
